import importAllImg from "../helpers/import-all-imgs";
import {useIntl} from "react-intl";

const imgs = importAllImg(require.context('../img/npf', false, /\.(png|jpe?g|svg)$/));

export default function NotFound() {
  const { formatMessage, locale } = useIntl();
  const fm = id => formatMessage({id});

  return (
    <div className="min-h-[200px] mt-[50px] md:mt-auto w-full bg-white text-neutral-900">
      <div className="relative">
        <img src={imgs['404.png']} alt="404" className="w-full" />
        <div className="absolute right-[15%] top-[20%] flex h-[30%] w-[40%] lg:w-[25%] items-center justify-center rounded-3xl bg-white p-6 text-center text-xs  lg:text-xl font-bold md:p-8">
          {locale === 'en' ? 'Oops! This page does not exist. Looks like you took a wrong turn.' : 'Trang này không tồn tại. Có vẻ như bạn đã nhầm lẫn gì đó.'}
        </div>
      </div>
    </div>
  )
}


